<template>
  <nx-form-text
    :label="label"
    class="nx-seo-inheritable-text-field mb-4"
    :disabled="disabled"
    :name="name"
    v-model="draft"
    v-on="$listeners"
    v-bind="$attrs"
    :placeholder="placeholder"
    :hint="effectiveValue"
    :counter="effectiveCounter"
    persistent-hint
  >
    <nx-seo-origin-chip :value="origin" v-if="!draft && placeholder" slot="append"></nx-seo-origin-chip>
  </nx-form-text>
</template>

<script>
import FormText from '@/modules/form/components/FormText';
import BaseField from '@/modules/seo/components/BaseField';
import OriginChip from '@/modules/seo/components/OriginChip';

export default {
  name: 'nx-seo-inheritable-text-field',
  extends: BaseField,
  components: {
    [FormText.name]: FormText,
    [OriginChip.name]: OriginChip,
  },
  props: {
    counter: {
      type: [Number, Boolean],
      optional: true,
    },
  },
  computed: {
    effectiveCounter() {
      if (this.counter) {
        return this.counter;
      }
      const excludedFields = [
        'canonicalUrl',
      ];
      return !excludedFields.includes(this.name);
    },
  },
};
</script>
